import React from 'react'
import Container from '../../Container'
import clsx from 'clsx'
import styles from '../form-controls.module.scss'
import Typography from '../../Typography'
import PropTypes from 'prop-types'

const HelperText = ({
  simpleHelperStyle = false,
  children,
  className,
}) => {
  return (
    <Container
      display={'flex'}
      className={clsx(styles['control__helperText'], className, {
        [styles['control__helperText_simple']]: simpleHelperStyle,
      })}
    >
      <Typography
        variant={'Body-10'}
        component={'div'}
      >
        {children}
      </Typography>
    </Container>
  )
}

HelperText.propTypes = {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  simpleHelperStyle: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  className: PropTypes.string,
}

export default HelperText
